import React, { useEffect } from "react";
import { scriptLoader } from "../metype-react/metype-script-loader";
import SelectDropdown from "../SelectDropdown";
import { string, array, number, func } from "prop-types";

export const MetypeContributionWidget = ({
  host,
  accountId,
  publisher,
  fontFamily,
  fontUrl,
  onChangeFunc,
  entities,
  currentItem,
}) => {
  const randomNumber = new Date().getMilliseconds();
  const defaultItem = { name: "Select Topic", "external-id": "Select Topic" };

  useEffect(() => {
    !window.talktype && scriptLoader(host, () => initWidget(randomNumber));
    initWidget(randomNumber);
  }, []);

  const initWidget = (randomNumber) => {
    if (window.talktype) {
      window.talktype.contributionWidgetIframe(document.getElementById(`metype-contribution-${randomNumber}`));
    }
  };

  return (
    <div>
      {entities && (
        <SelectDropdown
          list={entities}
          onChange={onChangeFunc}
          defaultItem={defaultItem}
          className="dropdown-list"
          selected={currentItem}
        />
      )}
      <div
        id={`metype-contribution-${randomNumber}`}
        data-metype-account-id={accountId}
        data-metype-host={host}
        data-metype-publisher={publisher}
        data-metype-font-url={fontUrl || ""}
        data-metype-font-family={fontFamily || ""}
      ></div>
    </div>
  );
};

MetypeContributionWidget.propTypes = {
  host: string,
  accountId: number,
  publisher: string,
  fontFamily: string,
  fontUrl: string,
  storyAttributes: array,
  onChangeFunc: func,
  entities: array,
  currentItem: string,
};
